class SupportTicketDetailViewController extends MUIViewController
{
    static newInstance() : SupportTicketDetailViewController {
        let vc = new SupportTicketDetailViewController( "support-ticket-detail-view" );
        vc.initWithResource( "layout/supportticket/SupportTicketDetailView.html" );
        return vc;
    }
}